<template>
  <div>

    <footer>
      <b-container>
        <b-row class="main-row">
          <b-col cols="12" sm="12" md="2" class="text-center text-md-left">
            <div class="copyright">{{ $t('copyright') }}</div>
          </b-col>
          <b-col cols="12" md="3" class="text-center text-md-left align-middle">
            <a href="https://www.facebook.com/finefitofficial" target="_blank" :title="$t('footer.follow.facebook')"><img src="https://finefit.s3.eu-north-1.amazonaws.com/images/social_facebook.svg" width="24" /></a>
            <a href="https://www.instagram.com/finefitofficial" target="_blank" :title="$t('footer.follow.instagram')"><img src="https://finefit.s3.eu-north-1.amazonaws.com/images/social_instagram.svg" width="24" /></a>
            <a href="https://www.linkedin.com/company/finefit" target="_blank" :title="$t('footer.follow.linkedin')"><img src="https://finefit.s3.eu-north-1.amazonaws.com/images/social_linkedin.svg" width="24" /></a>
            <a href="https://twitter.com/finefitofficial" target="_blank" :title="$t('footer.follow.twitter')"><img src="https://finefit.s3.eu-north-1.amazonaws.com/images/social_twitter.svg" width="24" /></a>
          </b-col>
          <b-col cols="12" sm="12" md="7" class="text-center text-md-right">
            <b-nav pills>
              <b-nav-item :to="{ name: `Home.${$i18n.i18next.language}` }">{{ $t('pages.home') }}</b-nav-item>
              <b-nav-item :to="{ name: `Contacts.${$i18n.i18next.language}` }">{{ $t('pages.contacts') }}</b-nav-item>
              <b-nav-item v-if="1 === 2" :to="{ name: `Account.${$i18n.i18next.language}` }">{{ $t('pages.account') }}</b-nav-item>
              <b-nav-item :to="{ name: `Pricing.${$i18n.i18next.language}` }">{{ $t('pages.pricing') }}</b-nav-item>
              <b-nav-item :to="{ name: `Terms.${$i18n.i18next.language}` }">{{ $t('pages.termsOfServices') }}</b-nav-item>
              <b-nav-item :to="{ name: `Privacy.${$i18n.i18next.language}` }">{{ $t('pages.privacyPolicy') }}</b-nav-item>
            </b-nav>
          </b-col>
        </b-row>
        <b-row v-if="1 === 2">
          <b-col class="contacts text-right mt-3">
            <div class="d-inline-block"><strong>{{ $t('footer.email') }}:</strong> <a href="mailto:peteris@kelle.ventures">peteris@kelle.ventures</a></div>
            <div class="d-inline-block ml-3"><strong>{{ $t('footer.phone') }}:</strong> +371 261 260 86</div>
          </b-col>
        </b-row>
        <div v-if="1 === 2 && !_.isEmpty(user)">
          <div v-if="!_.isEmpty(user.roles)">
            <router-link v-if="user.roles.admin" :to="{ name: `Management.${$i18n.i18next.language}` }">{{ $t('pages.management') }}</router-link>
          </div>
        </div>
      </b-container>
    </footer>

  </div>
</template>

<script>
  export default {
    name: 'site-footer',
    computed: {
      user: function () {
        return this.$store.getters.user
      }
    },
    methods: {

    },
  }
</script>

<style lang="scss" scoped>


  footer {
    padding: 2rem 0;

    .main-row {
      align-items: center;
    }

    .copyright {
      margin: 10px 0;
    }

    .nav-pills {
      float: right;

      .nav-item {

        .nav-link {
          border-radius: 0;

          &.active {
            font-weight: bold;
            border-bottom: 2px solid black;
            background: none;
          }

          &:hover {
            border-bottom: 2px solid black;
          }
        }

        @include media-breakpoint-down(sm) {
          display: block;
        }
      }

      @include media-breakpoint-down(sm) {
        display: block;
        float: none;
      }
    }

    a {
      color: black !important;
    }

    .contacts {
      font-size: 0.8rem;
    }
  }
</style>
